/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { isInstantJoinTechnicallySupported } from './ProductCompatibilityService';

export interface SessionOptions {
  nativeEndpointDisabled: boolean;
  webViewerDefault: boolean;
}

export interface MeetingInfo {
  build: string;
  nativeEPCompatibleVersions: string;
  sessionOptions: SessionOptions;
  authorizationCode?: string;
}

export const isInstantJoinOfferedAndSupported = (
  meetingInfo: MeetingInfo
): boolean => {
  return (
    isInstantJoinTechnicallySupported &&
    meetingInfo.sessionOptions.webViewerDefault
  );
};

export const isInstantJoinOffered = (meetingInfo: MeetingInfo): boolean => {
  return meetingInfo.sessionOptions.webViewerDefault;
};

export const isDesktopOnly = (
  meetingInfo: MeetingInfo,
  isDesktopEnforced?: boolean
): boolean => {
  return !isInstantJoinOffered(meetingInfo) || !!isDesktopEnforced;
};

export const isWebAllowed = (isDesktopEnforced?: boolean): boolean => {
  return isInstantJoinTechnicallySupported && !isDesktopEnforced;
};
